import type { FaireProductEntity } from "../../entity_types/product";

export const p_9r0wmyqt: FaireProductEntity = {
  token: "p_9r0wmyqt",
  type: "product",
  name: "Amber Apothecary Wood Wick Soy Candle ",
  brandName: "Woodfire Candle Company",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/962314051852d390d629b5e906b9761db5498e8a10b9952af19350a1957be601/1560189908.jpg",
  priceDollars: 12,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/4eff0ce370003df5d1d80ee761fed350b005bc31852d761b7c5913d14e411f58.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
